import React, { useContext, useMemo, useState } from 'react';
import { shallowEqual, useSelector } from 'umi'
import { FilterContext } from "@/pages/dashboard/components/PageContainer/context";
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import './ServiceTypes';
import { fillRealtimeEventData } from '../../_config/common';
import { getAccumulation, getAccumulationListFromFilterValue } from '@/pages/dashboard/utils/filter';

export default function realtimeRevenueService(props: any) {
  const { style, className, type, config, children, data : propsData, ...resetProps } = props || {}
  const { api, dataKey, isDark=false,refreshKey='', interval } = config || {}
  const [dataBy, setDataBy] = useState('country'); //后续下拉组件封装好了需要传入dataBy
  const  { filterVal } = useContext(FilterContext);

  const { gameCode } = useSelector((state: any) => {
    return {
      gameCode: state?.dashboard?.currentGame?.game_code,
    }
  }, shallowEqual)

  const data = useMemo(() => {
    return {
      gameCode,
      isDark,
      ...(propsData || {})
    }
  }, [gameCode, propsData,isDark])

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        dataKey={dataKey}
        refreshKey={refreshKey}
        interval={interval}
        beforeRequest={(data) => {
          const { filterVal, gameCode } = data;
          const { singleDaily, contrastDaily, timeType, diff, timeDiff, ...filters } = filterVal || {};
          //传参兜底筛选器参数
          let params: IApiParamsBase | IApiParamsWithKey = {
            game_code: gameCode,
            filters: formatFilterValues(filters),
            date: singleDaily,
            contrast_day: contrastDaily,
          };

          if (dataKey === 'date_event_list') {
            delete params.contrast_day;
            delete params.date;
            params = {
              ...params,
              start_time: singleDaily,
              end_time: singleDaily,
              period: 'hours',
            };
          }

          return params;
        }}
        trackData={['gameCode','isDark']}
        formatData={(response)=>{
          if(dataKey === 'date_event_list'){
            // 事件管理去掉last_moment选项（接口现在不返回，为兼容逻辑在返回值后添加）
            const addItem = {
              date: filterVal?.singleDaily || '',
              time: "last_moment",
              events: 0,
              event_list: []
            }

            const apiData = response?.list?.length ? [...(response?.list || []), addItem] : []
            return fillRealtimeEventData(apiData, 10, 143)
          }
          return response
        }}
        >
        {React.Children.map(children, (child: any) => {
          return React.cloneElement(
            child,
            {
              filterVal,
              ...resetProps,
              state: {}
            }
          );
        })}
      </Service>
    </div>
  );
};